<template>
  <div class="hello">
    <img class="cover-pic" src="../assets/cover_card.png">
    <h1 class="title">信用卡额度测试</h1>
    <h3 class="subtitle"> 高富帅 or 屌丝？<br> 1分钟测出你的信用卡额度 </h3>
    <div class="start-btn" @click="goTest">开始测试</div>
  </div>
</template>

<script>
export default {
  methods: {
    goTest () {
      this.$dispatch('changeView', 'q1', 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover{
  position: absolute;
  width: 100%;
  min-height: 100%;
  background: #fff;
}
.cover-pic{
  margin: 8rem auto 0;
  width: 20rem;
  display: block;
}
.title{
  margin: 2rem 0 1rem;
  text-align: center;
  font-weight: normal;
  font-size: 2rem;
  color:#333;
}
.subtitle{
  margin: 0;
  text-align: center;
  font-weight: normal;
  font-size: 1.5rem;
  color: #8c8c8c;
}
.start-btn{
  width: 80%;
  margin: 5rem auto 0;
  text-align: center;
  background: #d94b40;
  font-size: 1.5rem;
  padding: 1rem;
  color: #fff;
  border-radius: 0.5rem;
  font-weight: normal;
}
</style>



/** WEBPACK FOOTER **
 ** cover.vue?4320bdf6
 **/